export const mainVehicle = (state) => state.mainVehicle;

export const vehicles = (state) => state.vehicles;
